import { BaseEntity } from "@app/models/rest/base-entity";
import { Job, Job_BasicProjection } from "./job";
import { VisitType, VisitType_IdOnlyProjection } from "./visit-type";
import { VisitStatus } from "../enums/visit-status.enum";
import { Ticket_BasicProjection } from "@app/models/rest/ticket";
import {
  JobEmbeddedVisitSchedule,
  VisitSchedule_BasicProjection
} from "@app/models/rest/visit-schedule";
import { Team, TeamBasicProjection } from "@app/models/rest/team";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel,
  ProjectionRelType
} from "@lagoshny/ngx-hateoas-client";
import { JobStatus } from "@app/models/enums/job-status.enum";
import { Meeting, Meeting_BasicProjection } from "@app/models/rest/meeting";

export interface AutoBookProfile_BasicProjection {
  id: number;
  description: string;
  instantBook: boolean;
}

@HateoasResource("visits")
export class Visit extends BaseEntity {
  appointmentStart: Date;
  appointmentEnd: Date;
  visitStatus: VisitStatus;
  resourceCount: number;
}

@HateoasProjection(Visit, "anything")
export class Job_EmbeddedVisitProjection extends BaseEntity {
  externalJobReference: string;
  visitType: VisitType_IdOnlyProjection;
  appointmentStart: Date;
  appointmentEnd: Date;
  status: JobStatus;
  ticketList: Array<Ticket_BasicProjection>;
  visitScheduleList: JobEmbeddedVisitSchedule[];
  visitStatus: VisitStatus;
}

@HateoasProjection(Visit, "detail")
export class Visit_DetailProjection extends BaseEntity {
  appointmentStart: Date;
  appointmentEnd: Date;
  visitStatus: VisitStatus;
  resourceCount: number;

  @ProjectionRel(Job)
  job: Job_BasicProjection;

  @ProjectionRel(Meeting)
  meeting: Meeting_BasicProjection;

  @ProjectionRel(VisitType)
  visitType: ProjectionRelType<VisitType_IdOnlyProjection>;

  @ProjectionRel(Team)
  lockToTeam: ProjectionRelType<TeamBasicProjection>;

  ticketList: Ticket_BasicProjection[];
  visitScheduleList: VisitSchedule_BasicProjection[];
  autoBookProfileOverride?: AutoBookProfile_BasicProjection;
}
